import {
  Text,
  View,
  Pressable,
  ActivityIndicator,
  Dimensions
} from 'react-native'
import React, { FunctionComponent } from 'react'

import { UniversalWebView } from '../../components/UniversalWebView'

import styles from './Password.styles'
import { stdCouleurBleu } from '@commonStyle';

export const Password: FunctionComponent<{ onBack: () => void }> = ({ onBack }) => {
  const screenWidth = Dimensions.get('window').width;

  const injectedJavaScript = `
    const meta = document.createElement('meta');
    meta.setAttribute('content', 'width=${screenWidth}, initial-scale=0.8, maximum-scale=1, user-scalable=no');
    meta.setAttribute('name', 'viewport');
    document.getElementsByTagName('head')[0].appendChild(meta);

    // Suppression de l'entete Novadys
    const navBars = document.querySelectorAll('.navbar, .navbar-inverse, .navbar-fixed-top');
    navBars.forEach(navBar => {
      navBar.classList.remove('navbar', 'navbar-inverse', 'navbar-fixed-top');
      navBar.style.display = 'none';
    });

    // Recherche de l'élément avec la classe container-fluid
    const containerFluid = document.querySelector('.container-fluid');
    if (containerFluid) {
      containerFluid.style.width = '80%';
      containerFluid.style.margin = '0 auto';
    }

    // Ajouter des styles CSS pour contrôler le dimensionnement du contenu
    const style = document.createElement('style');
    style.innerHTML = \`
      .headerBarLogo {
        display: none !important;
      }
      .navbar, .navbar-inverse, .navbar-fixed-top {
        display: none !important;
      }
      body {
        overflow-x: hidden !important;
        min-width: 1px !important;
        padding-top: 0 !important;
        margin-top: 0 !important;
      }
      .container-fluid {
        padding-top: 20px !important;
      }
    \`;
    document.head.appendChild(style);
    
    true; // Indique que le script s'est exécuté avec succès
  `;

  return (
    <View style={styles.container}>
      <View style={styles.passwordResetContainer}>
        <UniversalWebView
          source={{ uri: 'https://password.jvsonline.fr/password/forgot?service=https%3A//emu-hc.jvsonline.fr/' }}
          style={styles.webView}
          javaScriptEnabled={true}
          domStorageEnabled={true}
          startInLoadingState={true}
          scalesPageToFit={true}
          //injectedJavaScript={injectedJavaScript}  
          renderLoading={() => (
            <View style={styles.loadingContainer}>
              <ActivityIndicator size="large" color={stdCouleurBleu} />
              <Text style={styles.loadingText}>Chargement...</Text>
            </View>
          )}
          onError={(event) => {
            console.warn('WebView error:', event);
          }}
          onHttpError={(event) => {
            console.warn('WebView HTTP error:', event);
          }}
        />
        <View style={styles.backButtonContainer}>
          <Pressable style={styles.backButton} onPress={onBack}>            
            <Text style={styles.backButtonText}>Retour</Text>
          </Pressable>
        </View>
      </View>
    </View>
  );
};
